import { Dashboard } from '@app/screens/Dashboard'

// Root
const root = '/'
// Login
const login = 'login'
const personalInfo = 'personal-info'
const interests = 'interests'
const showtime = 'showtime'
// Tipster Onboarding
const tipsterOnboarding = 'tipster'
const tipsterPersonalInfo = 'personal-info'
const tipsterInterests = 'interests'
const tipsterShowtime = 'showtime'
const tipsterMarket = 'market'
const tipsterBookie = 'bookies'
const tipsterChannel = 'channel'
const tipsterProfile = 'service'
const tipsterService = 'service'
// Feed
const feed = 'feed'
const content = 'content'
const channel = 'channel'
// App Settings
const appSettings = 'app-settings'
// Contact Form
const contactForm = 'support'
// Matches list
const matchesList = 'matches-list'
// Saved tips
const savedTips = 'saved-tips'
// Leaderboard
const leaderboard = 'leaderboard'
// Competition
const competition = 'competitions'
// Notifications
const notifications = 'notifications'
// Notifications Details
const notificationDetails = 'notification-details'
// Inbox
const inbox = 'inbox'
// Dashboard
const dashboard = 'dashboard'

// Profile
const profile = 'profile'
// Events voted
const matchesVoted = 'matches-voted'
// Banned screen
const banned = 'banned'
// Invite
const invite = 'channel-invite'
// Payment
const payment = 'payment'
const paymentResult = 'payment-result'
// Legal
const legal = 'legal'
// User subscriptions
const userSubscriptions = 'user-subscriptions'
// Tipster subscriptions
const tipsterSubscriptions = 'tipster-subscriptions'
const tipsterSubscriberList = 'subscribers'
// Tipster list (admin)
const tipsterList = 'tipster-list'
// Advertisements
const advertisements = 'advertisements'
// Bookies
const bookies = 'bookies'
// Bonuses
const bonuses = 'bonuses'
// Responsible gambling banners (admin)
const rgBanners = 'responsible-gambling'
// Match tracking
const matchTracking = 'match-tracking'
// Terms and contion
const tandC = 'legal'

// Install app
const install = 'landing'
const magicLink = 'magic-link'
const magicLinkSent = 'magic-link-sent'
const ChannelList = 'channel-list'
const authCallback = 'auth-callback'
const telegramAutoShare = 'telegram-autoshare'

export const ROUTES = {
  // Root
  root: `${root}`,
  // Login
  login: {
    short: `/${login}`,
    asParent: `/${login}/*`,
  },
  loginPersonalInfo: {
    short: `/${personalInfo}`,
    full: `/${login}/${personalInfo}`,
  },
  loginInterests: {
    short: `/${interests}/:onboardingStage`,
    full: `/${login}/${interests}/:onboardingStage`,
  },
  loginShowtime: {
    short: `/${showtime}`,
    full: `/${login}/${showtime}`,
  },
  // Tipster Onboarding
  tipsterOnboarding: {
    short: `/${tipsterOnboarding}/`,
    asParent: `/${tipsterOnboarding}/*`,
  },
  tipsterOnboardingPersonalInfo: {
    short: `/${tipsterPersonalInfo}`,
    full: `/${tipsterOnboarding}/${tipsterPersonalInfo}`,
  },
  tipsterOnboardingInterests: {
    short: `/${tipsterInterests}/:onboardingStage`,
    full: `/${tipsterOnboarding}/${tipsterInterests}/:onboardingStage`,
  },
  tipsterOnboardingShowtime: {
    short: `/${tipsterShowtime}`,
    full: `/${tipsterOnboarding}/${tipsterShowtime}`,
  },
  tipsterOnboardingBookie: {
    short: `/${tipsterBookie}`,
    full: `/${tipsterOnboarding}/${tipsterBookie}`,
  },
  tipsterOnboardingMarket: {
    short: `/${tipsterMarket}`,
    full: `/${tipsterOnboarding}/${tipsterMarket}`,
  },
  tipsterOnboardingProfile: {
    short: `/${tipsterProfile}/:step`,
    full: `/${tipsterOnboarding}/${tipsterProfile}/:step`,
  },
  tipsterOnboardingChannel: {
    short: `/${tipsterChannel}`,
    full: `/${tipsterOnboarding}/${tipsterChannel}`,
  },
  tipsterOnboardingService: {
    short: `/${tipsterService}`,
    full: `/${tipsterOnboarding}/${tipsterService}`,
  },
  // Channels
  feed: {
    short: `/${feed}`,
  },
  content: {
    full: `/${content}/:id`,
    short: `/${content}`,
  },
  channel: {
    short: `/${channel}`
  },
  channelProfile: {
    full: `/${channel}/:id`,
    short: `/${channel}`,
  },
  ChannelList: {
    short: `/${ChannelList}`
  },
  TelegramAutoShare: {
    short: `/${telegramAutoShare}`
  },
  // App Settings
  appSettings: {
    short: `/${appSettings}`,
  },
  // Contact Form
  contactForm: {
    short: `/${contactForm}`,
  },
  // Matches list
  matchesList: {
    short: `/${matchesList}`
  },
  // Saved tips
  savedTips: {
    short: `${root}${savedTips}`
  },
  // Leaderboard
  leaderboard: {
    short: `${root}${leaderboard}`
  },
  // Tournament
  competitions: {
    create: {
      short: `${root}${competition}/create`
    },
    view: {
      short: `${root}${competition}`
    },
    leaderboard: {
      short: `${root}${competition}/:id/leaderboard`
    },
    votes: {
      short: `${root}${competition}/:id/votes`
    },
    tipsterDetail: {
      short: `${root}${competition}/:id/tipster`
    },
  },
  // Profile
  profile: {
    full: `${root}${profile}/:id`,
    short: `${root}${profile}`
  },
  // Notifications
  notifications: {
    short: `${root}${notifications}`
  },
  notificationsDetails: {
    full: `${root}${notificationDetails}/:id`,
    short: `${root}${notificationDetails}`,
  },
  // Inbox
  inbox: {
    short: `${root}${inbox}`
  },
  dashboard: {
    short: `${root}${dashboard}`
  },
  // Matches voted
  matchesVoted: {
    short: `${root}${matchesVoted}`
  },
  // Banned screen
  banned: {
    short: `${root}${banned}`
  },
  // Invite
  invite: {
    short: `${root}${invite}`
  },
  // Payment
  payment: {
    short: `${root}${payment}`,
  },
  paymentResult: {
    short: `${root}${paymentResult}`,
  },
  // Legal
  legal: {
    short: `/${legal}`
  },
  // install
  install: {
    short: `${root}${install}`
  },
  // User subscriptions
  userSubscriptions: {
    short: `${root}${userSubscriptions}`,
  },
  tipsterSubscriptions: {
    short: `${root}${tipsterSubscriptions}`,
  },
  tipsterSubscriberList: {
    short: `${root}${tipsterSubscriberList}`,
  },
  tipsterList: {
    short: `${root}${tipsterList}`,
  },
  advertisements: {
    short: `${root}${advertisements}`,
    detail: `${root}${advertisements}/:id`,
  },
  bookies: {
    short: `${root}${bookies}`,
    create: `${root}${bookies}/create`,
    edit: `${root}${bookies}/:id`,
  },
  bonuses: {
    short: `${root}${bonuses}`,
    create: `${root}${bonuses}/create`,
    edit: `${root}${bonuses}/edit/:id`,
  },
  rgBanners: {
    short: `${root}${rgBanners}`,
  },
  matchTracking: {
    short: `${root}${matchTracking}`,
    full: `${root}${matchTracking}/:matchId`,
  },
  termsAndConditon: {
    short: tandC,
  },
  magicLink: {
    short: `${root}${magicLink}`,
  },
  magicLinkSent: {
    short: `${root}${magicLinkSent}`,
  },
  authCallback: {
    short: `${root}${authCallback}`,
  },
}

export const AFFILIATE_LINK_INTERNAL_NAME_KEY = 'affiliateLinkName'
export const INVITE_LINK_INTERNAL_NAME_KEY = 'inviteLinkName'
export const FOLLOW_TIPSTER_LINK_INTERNAL_NAME_KEY = 'followLinkName'
export const INVITEE_TIPSTER_LINK_INTERNAL_NAME_KEY = 'tivb'
export const VIP_INVITE_TOKEN_KEY = 'vipInvite'
export const APPLICATION_DEV_DOMAIN = 'https://tipsterizer.app/'
export const APPLICATION_PROD_DOMAIN = 'https://www.tipsterizer.app/'
export const INSTALL_TIPSTER_LINK_INTERNAL_NAME_KEY = 'installLinkName'
export const INSTALL_QUERY = ''

